import { TIER_PRICING } from '@vcard/shared';

export type SeatPlan = 'starter' | 'business';

export const euro = (cents: number): string =>
  `€${(Math.abs(cents) / 100).toLocaleString('de-DE', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;

/** Price of one seat in cents for the subscription's billing interval (year when unknown). */
export function seatUnitCents(plan: SeatPlan, interval: 'month' | 'year' | null): number {
  const p = TIER_PRICING[plan];
  return (interval === 'month' ? p.monthly : p.yearly) ?? 0;
}
